import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["genderSelect"]

  change(event) {
    const gender = event.target.dataset.rootTypeGenderValue
    if (gender && this.hasGenderSelectTarget) {
      this.genderSelectTarget.value = gender
    }
  }
}
